import React from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import {connect} from "react-redux";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import FeatureUtils from "../../utils/FeatureUtils";
import ConfigUtils from "qwc2/utils/ConfigUtils";
import {refreshLayer, removeLayer, LayerRole} from "qwc2/actions/layers";
import {removeDetailWindow} from "../../actions/details";

class FeaturedeleteTab extends AbstractTab {

    static propTypes = {
        feature: PropTypes.object,
        refreshLayer: PropTypes.func,
        removeDetailWindow: PropTypes.func,
        removeLayer: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            info: '',
            deleting: false
        };
    }

    deleteFeature = () => {
        if (this.state.deleting) {
            return;
        }
        if (!window.confirm(LocaleUtils.tr("featuredetails.deleteconfirm"))) {
            return;
        }
        this.setState({info: '', deleting: true});

        const current = this.props.feature;
        const url = FeatureUtils.prepareUrl(current, this.getUrl());
        const config = {
            headers: {
                'Authorization': FeatureUtils.prepareUrl(current, 'Bearer {token}'),
                'If-Match': '*'
            }
        };

        axios.delete(url, config)
            .then(() => {
                // remove the now-stale identify/selection highlight and force the WMS and the
                // hybrid (GeoJSON) layers to reload, then close the window - the deleted feature has nothing left to show
                this.props.removeLayer("identifyslection");
                this.props.refreshLayer(layer => layer.role === LayerRole.THEME || layer.type === "hybrid");
                this.props.removeDetailWindow({id: this.props.windowId});
            })
            .catch(error => {
                console.log('Error deleting', error);
                this.setState({deleting: false, info: LocaleUtils.tr("featuredetails.deletefailed")});
            });
    }

    getUrl() {
        if (this.props.tab.url) {
            return this.props.tab.url;
        }
        const objectType = FeatureUtils.getObjectType(this.props.feature);
        return ConfigUtils.getConfigProp("featureServiceUrl") + '/' + objectType + '/items/{uuid}';
    }

    render() {
        return (
            <div className="feature-details-ajax">
                <p>{LocaleUtils.tr("featuredetails.deletehint")}</p>
                <div>
                    <button className="button" disabled={this.state.deleting} onClick={this.deleteFeature} type="button">
                        {LocaleUtils.tr("featuredetails.delete")}
                    </button>
                </div>
                {this.state.info &&
                    <div>{this.state.info}</div>
                }
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    refreshLayer: refreshLayer,
    removeLayer: removeLayer,
    removeDetailWindow: removeDetailWindow
})(FeaturedeleteTab);
